// Reusable framer-motion variants for consistent scroll-reveal choreography.

export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1];
export const EASE_IN_OUT = [0.65, 0, 0.35, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE_OUT_EXPO },
  },
};

export const fadeUpStagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

// Line-by-line masked reveal (clip the container, slide the child up).
export const lineWrap = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08 },
  },
};

export const lineChild = {
  hidden: { y: "110%" },
  visible: {
    y: "0%",
    transition: { duration: 1.05, ease: EASE_OUT_EXPO },
  },
};

// Small pop for badges/icons.
export const pop = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: EASE_OUT_EXPO },
  },
};

// Standard scroll viewport config (fires once, generous margin).
export const IN_VIEW = { once: true, margin: "-10% 0px -10% 0px" };
